import { ExportType } from '@/domain/pdf-reports/pdf-reports.type';
import { createAppAsyncThunk } from '@/domain/store.thunk';

import { ProjectType } from '../entities/project.entity';
import { exportPdf } from './export-pdf/export-pdf';
import { exportExcel } from './export-report-excel/export-excel';
import { exportScoreCards } from './export-score-cards/export-score-cards';

export interface ExportReportProjectActionParams {
  projectId: number;
  filename: string;
  exportType: ExportType;
  projectType: ProjectType;
}

export const exportProjectReport = createAppAsyncThunk(
  'project/exportProjectReport',
  async (
    params: ExportReportProjectActionParams,
    {
      extra: { projectExportReportGateway, snackbarGateway },
      getState,
      dispatch,
    },
  ): Promise<void> => {
    switch (params.exportType) {
      case ExportType.ONLY_RESULTS:
      case ExportType.FULL_ANSWER_AND_RESULTS: {
        await exportPdf(projectExportReportGateway, snackbarGateway, params);
        break;
      }
      case ExportType.SOCIAL_MEDIA_SCORE_CARDS: {
        await exportScoreCards(
          projectExportReportGateway,
          snackbarGateway,
          params,
        );
        break;
      }
      case ExportType.EXCEL_CO2_ANSWERS: {
        await exportExcel(
          params.filename,
          params.projectId,
          snackbarGateway,
          getState,
          dispatch,
        );
        break;
      }
    }
  },
);
